// src/components/ContactPage.js
import React from 'react';
import './ContactPage.css';
import ContactHero from './ContactHero';
import Contact from './Contact';
import DarkMap from './DarkMap'; 
import Copyright from './Copyright';
import { useTranslation } from "react-i18next";

export default function ContactPage() {
  const { t } = useTranslation("contactPage");

  return (
    <main className="contact-page">
   <ContactHero imageUrl="/Images/picture_contact_2.jpg" objectPosition="42% 50%" />

      {/* GRID: Form + Map */}
      <section className="contact-grid">
        {/* Colonne gauche : texte + formulaire */}
        <div className="contact-col">
          <h2 className="nlz-title">{t("hero.title")}</h2>
          <div className="text-style-description">
  <p>
 {t("hero.intro")}
  </p>
</div>

          <div className="contact-card">
            <Contact />
          </div>
        </div>

        {/* Colonne droite : titre + infos + carte */}
        <div className="contact-col">
          <h2 className="nlz-title">{t("rightColumn.title")}</h2>

          <div className="contact-card">
            <h3 className="contact-subheading company">EMOTIONS AVIATION</h3>
            <ul className="contact-infos">
              <li>
    <strong>{t("rightColumn.infos.addressLabel")}:</strong> {t("rightColumn.infos.address").split("\n").map((line, i) => <React.Fragment key={i}>{line}<br/></React.Fragment>)}
  </li>
               <li>
    <strong>{t("rightColumn.infos.phoneLabel")}:</strong> <a href="tel:+33677407477">+33 6 77 40 74 77</a>
  </li>
              <li>
    <strong>{t("rightColumn.infos.emailLabel")}:</strong> <a href="mailto:contact@aerolux.com">emotion.aero@gmail.com</a>
  </li>
            </ul>

            <div className="map-frame-wrap">
              <DarkMap /> {/* ou <WhiteMap /> */}
            </div>
          </div>
        </div>
      </section>
      <Copyright/>
    </main>
  );
}
